import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { flatMap, map, catchError } from 'rxjs/operators';
import { Epic, ofType } from 'redux-observable';
import { getOptionsObject } from '../../utils/api';
import {
  FETCH_PARTICIPANT_PROFILE,
  fetchParticipantProfileSuccess,
  fetchParticipantProfileError,
  FETCH_PLANS,
  fetchPlansSuccess,
  fetchPlansError,
  FETCH_RIX_COMPENSATION,
  fetchRixCompensationSuccess,
  fetchRixCompensationError,
} from './actions';

export const fetchPlans: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_PLANS),
    flatMap(() =>
      ajax(getOptionsObject('/rps/participant-profile/plans'))
        .pipe(map((res: any) => fetchPlansSuccess(res.response)))
        .pipe(catchError(ex => of(fetchPlansError(ex)))),
    ),
  );

export const fetchParticipantProfile: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_PARTICIPANT_PROFILE),
    flatMap(action =>
      ajax(getOptionsObject(`/rps/participant-profile/participant?planNumber=${action.payload}`))
        .pipe(map((res: any) => fetchParticipantProfileSuccess(res.response)))
        .pipe(catchError(ex => of(fetchParticipantProfileError(ex)))),
    ),
  );

export const fetchRixCompensation: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_RIX_COMPENSATION),
    flatMap(() =>
      ajax(getOptionsObject('/rps/participant-profile/rix-compensation'))
        .pipe(map((res: any) => fetchRixCompensationSuccess(res.response)))
        .pipe(catchError(ex => of(fetchRixCompensationError(ex)))),
    ),
  );
